import { render } from "./AlumniView.vue?vue&type=template&id=da2cdbe4"
import script from "./AlumniView.vue?vue&type=script&lang=js"
export * from "./AlumniView.vue?vue&type=script&lang=js"

import "./AlumniView.vue?vue&type=style&index=0&id=da2cdbe4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__